import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { fmtDateTime, fmtDate } from "@/lib/format";
import { ReviewStatusBadge } from "@/lib/enquiries";

export default function ReviewsTable({ reviews, showDecision }) {
  const navigate = useNavigate();
  return (
    <div className="overflow-x-auto rounded-lg border bg-card">
      <table className="w-full text-sm" data-testid="reviewer-reviews-table">
        <thead>
          <tr className="border-b text-left text-xs uppercase tracking-wide text-muted-foreground">
            <th className="px-4 py-3 font-medium">Event ID</th>
            <th className="px-4 py-3 font-medium">Seller</th>
            <th className="px-4 py-3 font-medium">Material</th>
            <th className="px-4 py-3 font-medium">Assigned By</th>
            <th className="px-4 py-3 font-medium">Received On</th>
            <th className="px-4 py-3 font-medium">Deadline</th>
            <th className="px-4 py-3 font-medium">Status</th>
            {showDecision && <th className="px-4 py-3 font-medium">Decision</th>}
            <th className="px-4 py-3 font-medium text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          {reviews.length === 0 && (
            <tr><td colSpan={9} className="px-4 py-10 text-center text-muted-foreground" data-testid="reviews-table-empty">No reviews found.</td></tr>
          )}
          {reviews.map((r) => (
            <tr key={r.id} data-testid={`review-row-${r.id.slice(0, 8)}`} className="border-b transition-colors last:border-0 hover:bg-slate-50">
              <td className="px-4 py-3 font-mono text-xs font-semibold">{r.enquiry_number}</td>
              <td className="px-4 py-3 font-medium">{r.supplier_name}</td>
              <td className="px-4 py-3 text-xs">{r.material_summary}</td>
              <td className="px-4 py-3 text-xs">{r.assigned_by}</td>
              <td className="px-4 py-3 text-xs">{fmtDate(r.assigned_at)}</td>
              <td className={`px-4 py-3 text-xs ${r.overdue ? "font-semibold text-[#DC2626]" : ""}`}>{r.deadline ? fmtDateTime(r.deadline) : "—"}</td>
              <td className="px-4 py-3"><ReviewStatusBadge status={r.status} displayStatus={r.display_status} /></td>
              {showDecision && <td className="px-4 py-3 text-xs capitalize">{r.decision}</td>}
              <td className="px-4 py-3 text-right">
                <Button size="sm" data-testid={`review-open-${r.id.slice(0, 8)}`} onClick={() => navigate(`/technical-reviewer/reviews/${r.id}`)}
                  className="bg-slate-900 hover:bg-slate-800">Review</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
